var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 77,
    viewBox: "0 0 52 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8366 77C19.9206 77 25.67 71.2506 25.67 64.1666V51.3333H12.8366C5.75263 51.3333 0.0032959 57.0826 0.0032959 64.1666C0.0032959 71.2506 5.75263 77 12.8366 77Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0032959 38.5C0.0032959 31.416 5.75263 25.6667 12.8366 25.6667H25.67V51.3334H12.8366C5.75263 51.3334 0.0032959 45.584 0.0032959 38.5Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00317383 12.8333C0.00317383 5.74933 5.75251 0 12.8365 0H25.6698V25.6667H12.8365C5.75251 25.6667 0.00317383 19.9173 0.00317383 12.8333Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6698 0H38.5031C45.5871 0 51.3365 5.74933 51.3365 12.8333C51.3365 19.9173 45.5871 25.6667 38.5031 25.6667H25.6698V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3365 38.5C51.3365 45.584 45.5871 51.3334 38.5031 51.3334C31.4191 51.3334 25.6698 45.584 25.6698 38.5C25.6698 31.416 31.4191 25.6667 38.5031 25.6667C45.5871 25.6667 51.3365 31.416 51.3365 38.5Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.3397,
    height: 77,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosFigma);
export default __webpack_public_path__ + "static/media/logos_figma.b41f0189881b2ae7ac52fc89a38e180f.svg";
export { ForwardRef as ReactComponent };